import { useState, useEffect } from 'react';
import useFetchBasicRequest from '../../../hooks/useFetchBasicRequest';
import { FilterDataManager } from '../FilterDataManager';

const useApiFilterData = ( context ) => {
  const [ filterData, setFilterData ] = useState({});
  const [ navDataSource, setNavDataSource ] = useState( [] );
  const [ currentPostType, setCurrentPostType ] = useState( 'books' );
  const [ postTitle, setPostTitle ] = useState( '' );

  const {
    makeRequest,
    data
  } = useFetchBasicRequest( [
    `wp-json/wp/v2/agerange?per_page=100`,
    `wp-json/wp/v2/bookcategory?per_page=100`,
    `wp-json/wp/v2/brand?per_page=100`,
    `wp-json/wp/v2/imprint?per_page=100`,
    `wp-json/wp/v2/series?per_page=100`,
    `wp-json/wp/v2/booktheme?per_page=100`,
    `wp-json/wp/v2/collection?per_page=100`,
  ], 'GET' );

  useEffect( () => {
    if ( data.length === 0 ) return;

    const dataManager = new FilterDataManager( data );
    const bodyClasses = document.body.classList;
    const postIDClass = [ ...bodyClasses ].find( item => item.startsWith( 'postid' ) );
    const postID = postIDClass?.split( '-' ).pop();
    const pageUrlParts = window.location.pathname.split( '/' ).filter( Boolean );

    const postTypeMap = {
      'book-category': 'book-category',
      'imprint': 'imprint',
      'series': 'series',
      'age-range': 'age-range',
      'brand': 'brand',
      'book-theme': 'book-theme',
      'collection': 'collection'
    };

    const getPostType = () => {
      if ( postTypeMap[pageUrlParts[0]] ) {
        return postTypeMap[pageUrlParts[0]];
      }

      if ( context?.featureBy === 'contributors' ) {
        return 'contributors';
      } 

      return 'books';
    };

    const currentPostType = getPostType();
    const associatedData = dataManager.getAssociatedData( currentPostType, postID );
    setFilterData( associatedData );
    setCurrentPostType( currentPostType );

    // Set post title
    const doc = new DOMParser().parseFromString( window.DP.post_title, 'text/html' );
    setPostTitle( doc.documentElement.textContent );

    // Set navigation data
    const showNav = dataManager.shouldShowNavigation( currentPostType, associatedData );
    if ( showNav ) {
      setNavDataSource( [
        associatedData.ageRange,
        associatedData.brand,
        associatedData.category,
        associatedData.collection,
        associatedData.imprint,
        associatedData.series,
        associatedData.theme
      ] );
    } else {
      setNavDataSource( [] );
    }
  }, [ data ] );

  useEffect( () => {
    makeRequest();
  }, [] );

  return {
    filterData,
    navDataSource,
    currentPostType,
    postTitle
  };
};

export default useApiFilterData;
